import { colors } from '@ajaibid/components';
import { N50, N100, primaryBackground, Y500, primary, N400 } from '@assets/colors';
import { css } from '@emotion/css';

export const stySDPContainer = css`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  background: ${colors.NEUTRAL_1};
`;

export const styOrderBookContainer = css`
  display: inline-block;
  width: 320px;
  border-radius: 4px;
  margin-left: 4px;

  background: ${colors.NEUTRAL_0};
  overflow: auto;
`;

export const styOrderBookInner = css`
  padding: 16px;
`;

export const styContentContainer = css`
  display: inline-block;
  width: calc(100% - 324px);
  border-radius: 0px 4px 4px 0px;

  background: ${colors.NEUTRAL_0};
  overflow: hidden auto;
`;

export const styContainerPortfolioDetail = css`
  margin: 12px 24px 28px;
  padding: 20px;
  border: solid 1px ${N100};
  border-radius: 8px;
  display: flex;
  gap: 20px;
  overflow: hidden;

  > {
    :first-child {
      flex: 91px 0 0;

      border-right: 1px solid ${N100};
      margin-top: 0;
      margin-right: '4px';
    }

    :nth-child(2) {
      display: flex;
      gap: 20px;
      flex-wrap: wrap;
    }
  }
`;

export const styTabs = css`
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 16px;
  padding: 0;
  margin: 12px 24px 28px;
  border-bottom: 1px solid ${N50};
  width: 1090px;
`;

export const styTab = (isActive) => css`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 32px;
  font-size: 15px;
  line-height: 18px;
  font-weight: ${isActive ? '700' : '400'};
  cursor: pointer;
  padding: 4px 8px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  color: ${isActive ? primary : N400};
  box-shadow: 0px 2px 0px ${isActive ? primary : 'transparent'};
  &:hover {
    color: ${primary};
    box-shadow: 0px 2px 0px ${primary};
  }
`;

const styles = {
  subMenus: {
    display: 'inline',
  },
  containerContentData: {
    paddingLeft: 24,
    paddingRight: 24,
  },
  iconOnlineModal: {
    width: 32,
    height: 32,
  },
  iconAbout: {
    width: 16,
    height: 16,
  },
  imgPopup: {
    maxWidth: 488,
    height: 'auto',
  },
  accelerationBoard: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: 24,
    padding: 9,
    borderRadius: 25,
    backgroundColor: primaryBackground,
    height: 34,
    alignItems: 'center',
    justifyContent: 'center',
  },
  notationBox: {
    width: 16,
    height: 16,
    marginRight: 8,
    borderRadius: 4,
    backgroundColor: Y500,
    justifyContent: 'center',
    textAlign: 'center',
  },
};

export default styles;
